import { mpClickDocLink } from "./mixpanel";
export const appUtmParams = "?utm_source=intelligems_app";
const openNewTab = (
  link: string,
  mixpanelTracker?: string,
  noUtmParams?: boolean
) => {
  window.open(
    `//${link}${noUtmParams ? "" : appUtmParams}`,
    "_blank",
    "noopener noreferrer"
  );
  if (mixpanelTracker) {
    mpClickDocLink(mixpanelTracker);
  }
};

export default openNewTab;
